import React from 'react';
import { Redirect, Route } from 'react-router';

import AppComponent from '../js/app.js';

import SectionIntro from '../js/sectionIntro.js';
// import  SectionIntro_variant from '../js/sectionIntro_variant.js';
import SectionPromotion from '../js/sectionPromotion.js';
import SectionPromotionUpdated from '../js/sectionPromotionUpdated.js';
import SectionBarri from '../js/sectionBarri.js';
import CarInsurance from '../js/sectionCarInsurance.js';
import SectionClientService from '../js/sectionClientService.js';
import SectionLocations from '../js/sectionLocations.js';
import SectionLocationsInTexas from '../js/sectionLocationsInTexas.js';
import SectionAgent from '../js/sectionAgent.js';
import SectionEmployment from '../js/sectionEmployment.js';
import SectionPhoneService from '../js/sectionPhoneService.js';
import SectionSendMoney from '../js/sectionSendMoney.js';
import SectionPaymentServices from '../js/sectionPaymentServices.js';
import SectionLoans from '../js/sectionLoans.js';
import SectionChecks from '../js/sectionChecks.js';
import SectionOthersServices from '../js/sectionOthersServices.js';
import SectionBfgResolution from '../js/resolution.js';
import SectionBfgCompliance from '../js/compliance.js';

import SectionBfgPrivacySt from '../js/PrivacySt.js';
import SectionBfgGLBANotice from '../js/sectionGLBANotice.js'
import SectionBfgPrivacyClover from '../js/PrivacyClover.js';

import SectionBfgESign from '../js/ESign.js';
import SectionBfgFileACompliant from '../js/FileaCompliant.js';
import SectionBfgStatesLLC from '../js/StatesLLC.js';
import FraudAware from '../js/FraudAware.js';
import UserAgreement from '../js/UserAgreement';
import LegalNotices from '../js/LegalNotices.js';

// import SectionBfgCompliance from '../js/compliance.2.js';
import SectionBfgTermsCond from '../js/TermsCond.js';
import SectionBfgNotice from '../js/notice.js';
import MApiCompWraper from '../js/mApiCompWraper.js';
import TobbacoPurchSalePol from '../js/TobbacoPurchSalePol.js';
import DocsTerms from '../js/docsterm.js'

import Covid19 from '../js/covid19.js';

// Section Subpoema and law enforcement request
import SectionSubpoemaLaw from '../js/sectionSubpoemaLaw.js';
// Section Elder Abuse
import SectionElderAbuse from '../js/sectionElderAbuse.js';
import SectionStatePrivacyRights from '../js/sectionStatePrivacyRights.js';
import SectionDoNotSellMyPersonalInformation from '../js/SectionDoNotSellMyPersonalInformation.js';

// Section data protection
import SectionDataProtection from '../js/dataProtection.js';

import SectionCustomerDocument from '../js/customerDocuments.js';
import TransactionTracker from "../js/transactionTracker.js";
import TransactionTrackerDmt from "../js/transactionTrackerDmt.js";
import SectionQuisqueyanaPolicy from '../js/SectionQuisqueyanaPolicy.js';

export default (
    <Route>
        <Route component={AppComponent}>
            <Route path="/" component={SectionIntro} />
            {/* <Route path="/indexvariant" component={SectionIntro_variant}/> */}
            <Route path="/promotions" component={SectionPromotionUpdated} />

            <Route path="/sendMoney" component={SectionSendMoney} />
            <Route path="/reloadCell" component={SectionPhoneService} />
            <Route path="/paymentServices" component={SectionPaymentServices} />
            {/*<Route path="/insurance" component={CarInsurance} />*/}
            <Route path="/checkCashing" component={SectionChecks} />
            <Route path="/otherServices" component={SectionOthersServices} />
            <Route path="/aboutBarri" component={SectionBarri} />
            <Route path="/clientService" component={SectionClientService} />
            <Route path="/covid19" component={Covid19} />
            <Route component={MApiCompWraper} >
                <Route path="/locations" component={SectionLocations} />
                <Route path="/loans" component={SectionLoans} />
            </Route>
            <Route path="/texaslocations" component={SectionLocationsInTexas} />
            <Route path="/agent" component={SectionAgent} />
            <Route path="/employment" component={SectionEmployment} />
            <Route path="/careers.aspx" component={SectionEmployment} />
            <Route path="/empleo.aspx" component={SectionEmployment} />
            <Route path="/bfgCompliance" component={SectionBfgCompliance} />

            <Route path="/bfgPrivacySt" component={SectionBfgPrivacySt} />
            <Route path="/bfgglbanotice" component={SectionBfgGLBANotice} />
            <Route path="/bfgPrivacyClover" component={SectionBfgPrivacyClover} />
            <Route path="/bfgTermsCond" component={SectionBfgTermsCond} />
            <Route path="/bfgDocsTermsCond" component={DocsTerms} />

            <Route path="/bfgESign" component={SectionBfgESign} />
            <Route path="/BfgFileACompliant" component={SectionBfgFileACompliant} />
            <Route path="/BfgStatesLLC" component={SectionBfgStatesLLC} />
            <Route path="/FraudAware" component={FraudAware} />
            <Route path="/UserAgreement" component={UserAgreement} />
            <Route path="/LegalNotices" component={LegalNotices} />


            <Route path="/bfgResolution" component={SectionBfgResolution} />
            <Route path="/bfgNotice" component={SectionBfgNotice} />
            <Route path="/bfgtobbacoPurchSalePol" component={TobbacoPurchSalePol} />
            <Route path="/LawEnforcementRequest" component={SectionSubpoemaLaw} />
            <Route path="/ElderyFinancialAbuse" component={SectionElderAbuse} />
            {/* State Privacy Rights */}
            <Route path="/bfgStatePrivacyRights" component={SectionStatePrivacyRights} />
            {/* Data Protection */}
            <Route path="/dataProtection" component={SectionDataProtection} />
            <Route path="/bfgDoNotSellMyPersonalInformation" component={SectionDoNotSellMyPersonalInformation} />
            <Route path="/cd" component={SectionCustomerDocument} />

        </Route>
        <Route path="/transactiontrack" component={TransactionTracker} />
        <Route path="/tt" component={TransactionTrackerDmt} />

        <Redirect path="/quisqueyanaprivacy/" to="/quisqueyanaprivacy"/> 
        <Route path="/quisqueyanaprivacy" section="privacy" component={SectionQuisqueyanaPolicy} />
        <Redirect path="/quisqueyanaterms/" to="/quisqueyanaterms"/> 
        <Route path="/quisqueyanaterms" section="terms" component={SectionQuisqueyanaPolicy} />
        <Redirect path="/quisqueyanaesign/" to="/quisqueyanaesign"/> 
        <Route path="/quisqueyanaesign" section="esign" component={SectionQuisqueyanaPolicy} />
        <Redirect path="/quisqueyanaagreement/" to="/quisqueyanaagreement"/> 
        <Route path="/quisqueyanaagreement" section="agreement" component={SectionQuisqueyanaPolicy} />
        <Redirect path="/quisqueyanacomplaint/" to="/quisqueyanacomplaint"/> 
        <Route path="/quisqueyanacomplaint" section="complaint" component={SectionQuisqueyanaPolicy} />
        <Redirect path="/quisqueyananotices/" to="/quisqueyananotices"/> 
        <Route path="/quisqueyananotices" section="notices" component={SectionQuisqueyanaPolicy} />

    </Route>
);




// WEBPACK FOOTER //
// ./routes/routes.js